/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputIcon({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputIcon",
  fill,
  size
  
}) {
let dtTysiainputiconFillPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputIcon.fill.primary.base'
        })
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 width={size === "small" ? "16px" : "24px"}
 height={size === "small" ? "16px" : "24px"}
 fill={fill || dtTysiainputiconFillPrimaryBase}
>
{children}
</Children>
</React.Fragment>)
}